import React from 'react';
import { Dialog, DialogType, DialogFooter, PrimaryButton, DefaultButton } from '@fluentui/react';
import useAxios from 'axios-hooks';

const DeleteConfirmationModal = ({
  isOpen,
  onDismiss,
  attribute,
  cobrandList,
  onDeleteSuccess,
}) => {
  const [{ loading }, deleteAttribute] = useAxios(
    { url: 'internal/cobrand/attributes', method: "delete" },
    { manual: true }
  );

  const handleDelete = async () => {
    if (!attribute) return;

    const cobrandIdList = cobrandList.map(x => x.coBrandId).join(",");

    try {
      const result = await deleteAttribute({
        method: "delete",
        url: 'internal/cobrand/attributes',
        data: {
          attributeId: attribute.attributeId,
          attributeValue: attribute.attributeValue || '',
          cobrandIdList: cobrandIdList,
        },
      });

      if (!result.isAxiosError) {
        onDeleteSuccess();
      }
    } catch (error) {
      console.error('Error deleting attribute:', error);
    }
  };

  const dialogContentProps = {
    type: DialogType.normal,
    title: 'Confirm Delete',
    subText: attribute
      ? `Are you sure you want to delete "${attribute.attributeName}: ${attribute.attributeValue || '(empty)'}"?`
      : '',
  };

  return (
    <Dialog
      hidden={!isOpen}
      onDismiss={onDismiss}
      dialogContentProps={dialogContentProps}
      modalProps={{
        isBlocking: true,
      }}
    >
      <DialogFooter>
        <PrimaryButton onClick={handleDelete} text="Yes" disabled={loading} />
        <DefaultButton onClick={onDismiss} text="No" />
      </DialogFooter>
    </Dialog>
  );
};

export default DeleteConfirmationModal;
